import Feathers from './feathers'

class PageConfig extends Feathers {
    getPageConfig () {
        /*return this.request({
            url: `${ this.base }unit/service/settings`
        })*/
        return new Promise(async (resolve,reject) => {
            let unitsettings = await this.request({
            	url: `${ this.base }unit/service/settings`
        	});
        	let templatecommonsettings = await this.request({
            	url: `${ this.base }unit/service/defaultSettings`
        	});
        	if(templatecommonsettings.Data)
        	{
                let _templatecommonsettings = templatecommonsettings.Data;
        		for (let i  in _templatecommonsettings) 
				{
        			if(_templatecommonsettings[i].mode)
                    {
                        unitsettings.Data[i] = _templatecommonsettings[i].value;
                    }
                    if(!_templatecommonsettings[i].mode)
                    {
                        if(_templatecommonsettings[i].valuetype.toLowerCase()=='checkbox')
                        {
                           if(typeof(_templatecommonsettings[i].value)=="object")
                           {
                               unitsettings.Data[i] =  Array.from(new Set(unitsettings.Data[i].concat(_templatecommonsettings[i].value)));
                           }
                        }else
                        {
                            if(unitsettings.Data[i])
                            {
                                unitsettings.Data[i]+=',';
                            }
                            unitsettings.Data[i]+_templatecommonsettings[i].value;
                        }
                    }
        		}
        	}
            resolve(unitsettings);
        });
        
    }
}

export default PageConfig
